import { ComponentPropsWithoutRef } from "react"
import { Icon } from "../Icon"

export function InputInlineClearButton({ ...rest }: ComponentPropsWithoutRef<"button">) {
  return (
    <button className="flex h-6 items-center" type="button" aria-label="Clear" {...rest}>
      <Icon name="TimesCircle" size="sm" />
    </button>
  )
}
